



























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AdcontrolProfile } from "@/models";

@Component
export default class CompetitorsTotals extends Vue {
  @Prop({ required: true }) readonly totals!: {
    starts: number;
    startsSeconds: number;
    startsVod: number;
    startsVodTv: number;
    inclusion: number;
    inclusionSeconds: number;
    inclusionVod: number;
    inclusionVodTv: number;
    exclusive: number;
    exclusiveSeconds: number;
    exclusiveVod: number;
    exclusiveVodTv: number;
    exception: number;
    exceptionSeconds: number;
    exceptionVod: number;
    exceptionVodTv: number;
    sov: number;
  };

  @Prop({ default: false }) readonly loading!: boolean;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  get startsTv() {
    return this.totals.starts - this.totals.startsVod - this.totals.startsVodTv;
  }

  get inclusionTv() {
    return (
      this.totals.inclusion -
      this.totals.inclusionVod -
      this.totals.inclusionVodTv
    );
  }

  get exclusiveTv() {
    return this.totals.exclusive;
  }

  get exclusive() {
    return (
      this.totals.exclusive +
      this.totals.exclusiveVod +
      this.totals.exclusiveVodTv
    );
  }

  get exceptionTv() {
    return (
      this.totals.exception -
      this.totals.exceptionVod -
      this.totals.exceptionVodTv
    );
  }

  get showSeconds() {
    return !this.vod && !this.mixedVod;
  }

  get mixedVod() {
    return this.profile?.mediaSourceKind === "msk_vod_and_tv";
  }

  get vod() {
    return this.profile?.mediaSourceKind === "msk_vod";
  }
}
